<template>
  <div>
    <h4 class="workplatform-title m-t-10 m-b-10">合同基本信息</h4>
    <Row>
      <i-col span="8">
        <label class="title text-title-65">合同编号</label>{{ contractInfo.code }}
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">合同名称</span>{{ contractInfo.name }}
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">客户名称</span>{{ contractInfo.advertiserName }}
        <template v-if="contractInfo.secondParty">
          <Tag v-if="contractInfo.secondParty.partyType===10" color="green">企业</Tag>
          <Tag v-else color="cyan">个人</Tag>
        </template>
      </i-col>
    </Row>
    <Row class="p-b-5">
      <i-col span="8">
        <span class="title text-title-65">开始日期</span>{{ contractInfo.startDate }}
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">结束日期</span>{{ contractInfo.endDate }}
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">用途</span>{{ contractInfo.rentTypeName }}
      </i-col>
    </Row>
    <Row class="p-b-5">
      <i-col span="8">
        <span class="title text-title-65">创建人</span>{{ contractInfo.createUserName }}
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">创建时间</span>{{ contractInfo.createTime }}
      </i-col>
    </Row>
    <Row>
      <i-col span="24">
        <span class="title text-title-65">附加条款</span>{{ contractInfo.description }}
      </i-col>
    </Row>

    <h4 class="workplatform-title m-t-10 m-b-10">资产配置</h4>
    <p class="m-b-5">
      <a class="m-l-5" @click="showChangeLog"><Icon type="md-search" />查看历史变更记录</a>
    </p>
    <Table :columns="dataColumns"  stripe size="small" show-summary  :summary-method="handleSummary"
        :data="contractResources"></Table>

    <!-- 合同变更日志 -->
    <ChangeLog ref="changeLogRef"/>
    <!-- 变更计费策略 -->
    <ResourceSetting ref="resourceSettingRef" @on-change-success="initlistResourceAndFee"/>
  </div>
</template>

<script>
// componetns
import ChangeLog from './changeComponents/ChangeLog.vue'
import ResourceSetting from './changeComponents/ResourceSetting.vue'

// utils
import em from '@/utils/enum'
import Decimal from 'decimal.js'
// apis
import { getContractInfo, listObjectAndFee } from '@/api/invest/contract'

const MAX_CELL_ROW = 5

export default {
  props: {},
  components: {
    ChangeLog, ResourceSetting
  },
  data () {
    return {
      contractInfo: {},
      dateUnitArray: em.dateUnitArray,

      contractResources: [],
      dataColumns: [
        { title: '编码', dataIndex: 'objectCode', key: 'objectCode' },
        { title: '站点', dataIndex: 'stationName', key: 'stationName' },
        { title: '类型', dataIndex: 'resourceTypeName', key: 'resourceTypeName' },
        {
          title: '计费数量',
          key: 'number',
          align: 'center',
          render: (h, params) => {
            let unit = ''
            if (params.row.objectType === 3007) {
              unit = ' 台'
            } else if ([3006, 3013].includes(params.row.objectType)) {
              unit = ' ㎡'
            }

            return h('div', [
              h('span', params.row.number + unit)
            ])
          }
        },
        {
          title: '计费周期',
          key: 'feeStartDate',
          align: 'center',
          width: '180',
          className: 'inverst-price-column-top',
          render: (h, params) => {
            const resultStr = []
            params.row.feeList.forEach(item => {
              resultStr.push(h(
                'p', {},
                item.startDate + '至' + item.endDate
              ))
            })

            let showMore
            const tooMany = params.row.feeList.length > MAX_CELL_ROW
            const simple = tooMany ? resultStr.slice(0, MAX_CELL_ROW) : resultStr.slice(0)

            if (tooMany) {
              showMore = h(
                'a',
                {
                  on: {
                    click: () => {
                      params.row.showAll = !params.row.showAll
                    }
                  }
                },
                [
                  h('Icon', {
                    props: {
                      type: params.row.showAll
                        ? 'ios-arrow-down'
                        : 'ios-arrow-up',
                      color: '#4285f4',
                      size: 'large'
                    }
                  }),
                  h(
                    'span',
                    { style: { color: '#4285f4' } },
                    params.row.showAll ? '显示更多' : '隐藏'
                  )
                ]
              )
            }

            simple.push(showMore)
            resultStr.push(showMore)
            return h('div', params.row.showAll ? simple : resultStr)
          }
        },
        {
          title: '计费类型',
          key: 'feeTypeName',
          align: 'center',
          className: 'inverst-price-column-top',
          render: (h, params) => {
            const resultStr = []
            params.row.feeList.forEach(item => {
              resultStr.push(h(
                'p', {},
                item.feeTypeName
              ))
            })

            const simple = resultStr.slice(0, MAX_CELL_ROW)
            return h('div', params.row.showAll ? simple : resultStr)
          }
        },
        {
          title: '计费单价',
          key: 'feeSignPrice',
          align: 'right',
          className: 'inverst-price-column-top',
          render: (h, params) => {
            const resultStr = []
            params.row.feeList.forEach(item => {
              resultStr.push(h(
                'p', {},
                item.signPrice + '元/' + this.formatDateUnit(item.dateUnit)
              ))
            })

            const simple = resultStr.slice(0, MAX_CELL_ROW)
            return h('div', params.row.showAll ? simple : resultStr)
          }
        },
        {
          title: '计费小计',
          key: 'feeMonthPrice',
          align: 'right',
          className: 'inverst-price-column-top',
          render: (h, params) => {
            const resultStr = []
            params.row.feeList.forEach(item => {
              resultStr.push(h(
                'p', {},
                item.monthPrice + '元/' + this.formatDateUnit(item.dateUnit)
              ))
            })

            const simple = resultStr.slice(0, MAX_CELL_ROW)
            return h('div', params.row.showAll ? simple : resultStr)
          }
        },
        {
          title: '合计费用',
          key: 'totalPrice',
          align: 'right',
          className: 'inverst-price-column-top',
          render: (h, params) => {
            const resultStr = []
            params.row.feeList.forEach(item => {
              resultStr.push(h(
                'p', {},
                item.totalPrice
              ))
            })

            const simple = resultStr.slice(0, MAX_CELL_ROW)
            return h('div', params.row.showAll ? simple : resultStr)
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 140,
          render: (h, params) => {
            const detailButton = h(
              'a',
              {
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.handleRentSetting(params.row)
                  }
                }
              },
              '变更计费策略'
            )

            return h('div', [detailButton])
          }
        }
      ]
    }
  },
  mounted () {},
  created () {
    if (this.contractId) {
      this.initDetail()
      this.initlistResourceAndFee()
    }
  },
  methods: {
    initDetail () {
      // 载入合同信息
      getContractInfo({ contractId: this.contractId }).then(res => {
        this.contractInfo = res
      })
    },
    initlistResourceAndFee () {
      listObjectAndFee({ contractId: this.contractId }).then((res) => {
        this.contractResources = res.map(x => {
          return Object.assign(x, { showAll: true })
        })
      })
    },
    showChangeLog () {
      // this.modalShowContractDetail = true
      this.$refs.changeLogRef.showModal()
    },
    handleRentSetting (item) {
      this.$refs.resourceSettingRef.showModal(item)
    },
    handleSummary ({ columns, data }) {
      const sums = {}
      columns.forEach((column, index) => {
        const key = column.key
        if (index === 0) {
          sums[key] = {
            key,
            value: '总计'
          }
          return
        }

        if (key === 'totalPrice') {
          let total = 0
          data.forEach(element => {
            element.feeList.forEach(item => {
              total = Decimal.add(total, item.totalPrice).toNumber()
            })
          })

          sums[key] = {
            key,
            value: total
          }
        } else {
          sums[key] = {
            key,
            value: ''
          }
        }
      })

      return sums
    },
    formatDateUnit (type) {
      const unit = this.dateUnitArray.find(x => x.value === type)
      return unit ? unit.name : ''
    }
  },
  watch: {
    contractId () {
      this.initDetail()
    }
  },
  computed: {
    contractId () {
      return this.$store.state.investmentContract.id
    }
  }
}
</script>
